import React, { useCallback, useEffect, useState } from 'react';
import { Row, Col, Grid } from 'antd';
import { useSelector } from 'react-redux';
import indexStyles from './index.less';
import FrozenRatio from 'src/components/FrozenRatio/FrozenRatio';
import { useIntl } from 'react-intl';
import { localeSelector } from 'src/selector/app';
import useLocale from 'src/hooks/useLocale';
import Link from 'next/link';
import UnoptimizedImage from 'src/components/UnoptimizedImage';
import { LogosOnBrandWall } from 'src/consts/poswebsite_content/home';

const { useBreakpoint } = Grid;

export function CommonSectionLayout(props) {
  let { children, title, backgroundColor, classNames = '', description, subDescription, id } = props;

  return (
    <div className={`${indexStyles.CommonSectionLayout} ${classNames}`} style={{ backgroundColor }}>
      <div className="container common-section common-section-section">
        <div className="section-content ">
          {(title || description) && (
            <div className="header">
              {title && <h1 className="bold section-title">{title}</h1>}
              {description && <p className=" section-sub-title">{description}</p>}
              {subDescription}
            </div>
          )}
          {children}
        </div>
      </div>
    </div>
  );
}

export const ChowbusoneComposedTags = ({ backgroundColor = '#ffffff' }) => {
  const screens = useBreakpoint();
  const local = useLocale();
  const backgroundOriginalSizeWidth = 1312;
  const backgroundOriginalSizeHeight = 582;

  const resource = {
    imag: `${process.env.ASSETS_PREFIX}/home/compose_tags/chowbus_one_tags.jpg`,
    alt: {
      zh: 'Chowbus POS',
      en: 'Chowbus POS',
    },
    hotTags: [
      {
        position: {
          left: `${(215 * 100) / backgroundOriginalSizeWidth}%`,
          top: `${(232 * 100) / backgroundOriginalSizeHeight}%`,
        },
        tagText: {
          // zh: '手持刷卡机',
          // en: 'POS Terminal',
          zh: '手持POS',
          en: 'POS Handheld',
        },
        linkhref: '/products/handheld',
      },
      {
        position: {
          left: `${(325 * 100) / backgroundOriginalSizeWidth}%`,
          top: `${(396 * 100) / backgroundOriginalSizeHeight}%`,
        },
        tagText: {
          zh: '平板点餐',
          en: 'Tablet Ordering',
        },
        linkhref: '/products/tablet-ordering',
      },
      {
        position: {
          left: `${(630 * 100) / backgroundOriginalSizeWidth}%`,
          top: `${(506 * 100) / backgroundOriginalSizeHeight}%`,
        },
        tagText: {
          zh: '第三方平台集成',
          en: 'Third-party Integration',
        },
        linkhref: '/products/thirdparty-integration',
      },

      {
        position: {
          left: `${(610 * 100) / backgroundOriginalSizeWidth}%`,
          top: `${(353 * 100) / backgroundOriginalSizeHeight}%`,
        },
        tagText: {
          zh: 'Chowbus POS',
          en: 'Point of Sale',
        },
        linkhref: '/products/point-of-sale',
      },

      {
        position: {
          left: `${(952 * 100) / backgroundOriginalSizeWidth}%`,
          top: `${(486 * 100) / backgroundOriginalSizeHeight}%`,
        },
        tagText: {
          zh: '餐厅订餐网页',
          en: 'Online Ordering',
        },
        linkhref: '/products/online-ordering',
      },

      {
        position: {
          left: `${(820 * 100) / backgroundOriginalSizeWidth}%`,
          top: `${(69 * 100) / backgroundOriginalSizeHeight}%`,
        },
        tagText: {
          zh: '智能自助点餐机',
          en: 'Kiosk',
        },
        linkhref: '/products/kiosk-ordering',
      },
      {
        position: {
          left: `${(1050 * 100) / backgroundOriginalSizeWidth}%`,
          top: `${(296 * 100) / backgroundOriginalSizeHeight}%`,
        },
        tagText: {
          zh: '二维码点餐',
          en: 'QR Code Ordering',
        },
        linkhref: '/products/qrcode-ordering',
      },
      {
        position: {
          left: `${(1100 * 100) / backgroundOriginalSizeWidth}%`,
          top: `${(146 * 100) / backgroundOriginalSizeHeight}%`,
        },
        tagText: {
          zh: '餐厅专属会员系统',
          en: 'Restaurant Loyalty',
        },
        linkhref: '/products/loyalty',
      },
      {
        position: {
          left: `${(920 * 100) / backgroundOriginalSizeWidth}%`,
          top: `${(226 * 100) / backgroundOriginalSizeHeight}%`,
        },
        tagText: {
          zh: '餐厅排队系统',
          en: 'Waitlist',
        },
        linkhref: '/products/waitlist',
      },
    ],
  };
  if (screens.xs) {
    return null;
  }
  return (
    <CommonSectionLayout
      classNames={[
        indexStyles.chowbusoneComposedTags,
        screens.xs ? indexStyles.productsForspecicalNeedsMobile : '',
      ].join(' ')}
      backgroundColor={backgroundColor}
      title={''}
    >
      <FrozenRatio ratio={0.443703703703704}>
        <UnoptimizedImage
          layout="fill"
          className={'chowbusone-composed-tags-image'}
          src={resource.imag}
          alt={resource.alt[local]}
        />
        <div className={indexStyles.chowbusoneComposedTagsHotAreas}>
          {resource.hotTags.map((tag, index) => {
            let { position, tagText, linkhref } = tag;
            return (
              <Link href={linkhref} key={index} alt={tagText[local]}>
                <a>
                  <div className={indexStyles.chowbusoneTags} style={{ ...position }}>
                    <span className={indexStyles.plusicon}>+ </span>
                    {tagText[local]}
                  </div>
                </a>
              </Link>
            );
          })}
        </div>
        {/* <img /> */}
      </FrozenRatio>
    </CommonSectionLayout>
  );
};

export const OurClients = ({ original = false }) => {
  const intl = useIntl();
  let clientsLogo = [
    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/tiger_sugar.png`,
      alt: 'tigersugar',
      width: 164,
    },
    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/xiang_tian_xiao.png`,
      alt: 'xiang_tian_xiao',
      width: 164,
    },

    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/liu_yi_shou.png`,
      alt: 'liu_yi_shou',
      width: 164,
    },
    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/xiaolongkai.png`,
      alt: 'xiaolongkai',
      width: 164,
    },
    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/nan_huo_guo.png`,
      alt: 'nan_huo_guo',
      width: 164,
    },
    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/jiang_nan.png`,
      alt: 'jiang_nan',
      width: 164,
    },
    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/yuan_cha.png`,
      alt: 'yuan_cha',
      width: 164,
    },
    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/kyuramen_01.png`,
      alt: 'kyuramen',
      width: 164,
    },

    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/the_whale_tea.png`,
      alt: 'The Whale Tea',
      width: 134,
    },

    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/vivi_bubble_tea.png`,
      alt: 'Vivi Bubble Tea',
      width: 134,
    },

    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/xing_fu_tang.png`,
      alt: 'xing Fu Tang',
      width: 134,
    },

    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/machi_machi.png`,
      alt: 'machimachi',
      width: 164,
    },

    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/craftycrab.png`,
      alt: 'craftycrab',
      width: 164,
    },

    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/teamo_01.png`,
      alt: 'teamo',
      width: 164,
    },
    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/jing_liu_li_fan.png`,
      alt: 'jing_liu_li_fan',
      width: 164,
    },
    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/jongrobbq.png`,
      alt: 'jongrobbq',
      width: 164,
    },
    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/kong_fu_cha.png`,
      alt: 'kong_fu_cha',
      width: 164,
    },
    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/mochi_nut.png`,
      alt: 'mochi_nut',
      width: 164,
    },
    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/one_zo.png`,
      alt: 'one_zo.png',
      width: 164,
    },
    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/chao_cha.png`,
      alt: 'chao_cha.png',
      width: 164,
    },
    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/bu_er_jia.png`,
      alt: 'bu_er_jia.png',
      width: 164,
    },

    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/lao_jiu_men.png`,
      alt: 'lao_jiu_men.png',
      width: 164,
    },
    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/gang_guan_wu_qu.png`,
      alt: 'gang_guan_wu_qu.png',
      width: 164,
    },
    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/cha_tang_hui.png`,
      alt: 'cha_tang_hui.png',
      width: 164,
    },
    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/lao_sze_chuan.png`,
      alt: 'lao_sze_chuan.png',
      width: 164,
    },
    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/dun_huang.png`,
      alt: 'dun_huang.png',
      width: 164,
    },
    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/ma_la.png`,
      alt: 'ma_la.png',
      width: 164,
    },
    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/lao_gao_bbq.png`,
      alt: 'lao_gao_bbq.png',
      width: 164,
    },
    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/yu_wei_xiao_yu.png`,
      alt: 'yu_wei_xiao_yu.png',
      width: 164,
    },
    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/you_qin_ke_chuan.png`,
      alt: 'you_qin_ke_chuan.png',
      width: 164,
    },
    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/ka_ji_ken.png`,
      alt: 'ka_ji_ken.png',
      width: 164,
    },
    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/egg_lab.png`,
      alt: 'egg_lab.png',
      width: 164,
    },
    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/croffle_haus.png`,
      alt: 'croffle_haus.png',
      width: 164,
    },
    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/brooklyn.png`,
      alt: 'brooklyn.png',
      width: 164,
    },
    {
      logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/jongro_rice_hot_dog.png`,
      alt: 'jongro_rice_hot_dog.png',
      width: 164,
    },
  ];
  return (
    <CommonSectionLayout backgroundColor="#FFFFFF" title={intl.formatMessage({ id: 'home.ourclients.title' })}>
      <div className={`${indexStyles.ourClientsList}`}>
        <Row
          gutter={[
            { xs: 10, sm: 10, md: 10 },
            { xs: 10, sm: 10, md: 10 },
          ]}
        >
          {LogosOnBrandWall.map((logoName, index) => {
            // let { logo, alt, width } = info;
            let logo = `${process.env.ASSETS_PREFIX}/demo-new-logs/${logoName}`;
            let alt = logoName;
            let width = 164;
            return (
              <Col xs={6} md={4} lg={3} xxl={2} key={index}>
                <FrozenRatio ratio={1}>
                  <a className="client-logo-link">
                    <div className="client-logo-container">
                      {/* <img
                       
                      ></img> */}
                      <UnoptimizedImage
                        className={`client-logo-image  ${original ? 'showAsOriginal' : ''}`}
                        src={logo}
                        alt={alt}
                        objectFit="contain"
                        style={{ width: `${(width * 100) / 164}%` }}
                        layout="fill"
                      />
                    </div>
                  </a>
                </FrozenRatio>
              </Col>
            );
          })}
        </Row>
      </div>
    </CommonSectionLayout>
  );
};
